import { IGetActionInfoResult } from '../types/IActionInfo';
import { Request } from './Request';

export interface IGetBackGroundActionInfoParams {
  actionId: string;
}

export class GetBackgroundActionInfoRequest extends Request<IGetBackGroundActionInfoParams, IGetActionInfoResult> {
  constructor(params: IGetBackGroundActionInfoParams) {
    super('getBackgroundActionInfo', params);
  }
}

